import React from "react";
import { Bot, UserRound, Check } from "lucide-react";

function ConversationMode({ mode = "Bot", loading = false, onModeChange }) {
  const modes = [
    {
      value: "Bot",
      label: "Bot",
      description: "AI automation",
      icon: Bot,
    },
    {
      value: "Manual",
      label: "Manual",
      description: "Team handling",
      icon: UserRound,
    },
  ];

  const handleModeChange = async (newMode) => {
    if (loading || newMode === mode) {
      return;
    }

    await onModeChange?.(newMode);
  };

return (
  <div className="w-full rounded-md border border-border-light bg-card-bg p-1.5 shadow-[0_1px_4px_rgba(37,99,235,0.035)] dark:border-dark-border dark:bg-dark-card">
    <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-2">
      {modes.map((item) => {
        const Icon = item.icon;
        const isActive = mode === item.value;

        return (
          <button
            key={item.value}
            type="button"
            disabled={loading}
            onClick={() => handleModeChange(item.value)}
            className={`group relative flex min-w-0 items-center gap-2 rounded-lg px-2.5 py-2.5 text-left transition-all duration-200 ease-out ${
              isActive
                ? "border border-theme-100 bg-theme-50 shadow-[0_3px_10px_rgba(61,155,210,0.07)] dark:border-dark-primary/25 dark:bg-dark-soft-blue"
                : "border border-transparent text-text-muted hover:border-border-light hover:bg-app-bg hover:text-text-secondary dark:hover:border-dark-border dark:hover:bg-dark-soft-blue"
            } ${
              loading
                ? "cursor-not-allowed opacity-60"
                : "active:scale-[0.99]"
            }`}
          >
            {/* Active indicator */}
            {isActive && (
              <span className="absolute left-0 top-1/2 h-6 w-0.5 -translate-y-1/2 rounded-full bg-primary dark:bg-dark-primary" />
            )}

            {/* Icon */}
            <div
              className={`relative flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-lg border transition-all duration-200 ${
                isActive
                  ? "border-theme-100 bg-white text-primary shadow-[0_2px_6px_rgba(61,155,210,0.08)] dark:border-dark-border dark:bg-dark-card dark:text-dark-primary"
                  : "border-border-light bg-card-bg text-text-muted group-hover:border-theme-100 group-hover:bg-theme-50 group-hover:text-primary dark:border-dark-border dark:bg-dark-soft-blue dark:text-dark-text-muted"
              }`}
            >
              {isActive && (
                <span className="pointer-events-none absolute left-1 top-1 h-2 w-3 rounded-full bg-white/80 blur-[2px]" />
              )}

              <Icon
                size={14}
                strokeWidth={1.8}
                className="relative z-10"
              />
            </div>

            {/* Content */}
            <div className="min-w-0 flex-1">
              <p
                className={`truncate text-[10px] font-semibold tracking-[-0.01em] sm:text-[11px] ${
                  isActive
                    ? "text-primary dark:text-dark-primary"
                    : "text-text-secondary dark:text-dark-text-secondary"
                }`}
              >
                {item.label}
              </p>

              <p
                className={`mt-0.5 truncate text-[8px] leading-tight sm:text-[9px] ${
                  isActive
                    ? "text-primary/65 dark:text-dark-primary/70"
                    : "text-text-muted dark:text-dark-text-muted"
                }`}
              >
                {item.description}
              </p>
            </div>

            {/* Selected indicator */}
            {isActive && (
              <div className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-primary text-white shadow-[0_2px_6px_rgba(61,155,210,0.15)] dark:bg-dark-primary">
                <Check size={9} strokeWidth={2.6} />
              </div>
            )}
          </button>
        );
      })}
    </div>
  </div>
);
}

export default ConversationMode;